import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Footer } from '@innovationnorway/cl-react';
import { useAuth } from 'src/features/authorization';
import { useSupportEmail } from 'src/hooks/use-support-email';
import useSpaLinkClick from 'src/hooks/use-spa-link-click';
import css from './Footer.module.scss';

const BaseFooter: FC = () => {
  const { t } = useTranslation();
  const { t: tPageTitles } = useTranslation('pageTitles');
  const { email } = useSupportEmail();
  const { checkAccess } = useAuth();
  const hasOneWayInAccess = checkAccess('OneWayIn').read;

  const handleFooterClick = useSpaLinkClick();

  const fullYear = new Date().getFullYear();

  return (
    <div className={css['footer']} onClickCapture={handleFooterClick}>
      <Footer
        goToTop={{ label: t('toTheTop') }}
        bottomContent={<p>{t('footer.copyright', { date: fullYear })}</p>}
        footerBlocks={[
          {
            heading: t('needHelp'),
            items: [
              {
                link: {
                  title: t('getInContact'),
                  url: `mailto:${email}`,
                },
              },
            ],
          },
          {
            heading: t('shortcuts'),
            items: [
              {
                link: {
                  title: t('footer.declarityOfAvailability'),
                  url: 'https://uustatus.no/nb/erklaringer/publisert/4ca5cfd8-f091-42cf-b2f1-8c682f09b102',
                },
              },
              {
                link: {
                  title: t('termsOfUse'),
                  url: '/terms-of-use',
                },
              },
              ...(hasOneWayInAccess
                ? [
                    {
                      link: {
                        title: tPageTitles('graphical'),
                        url: '/entry-link',
                      },
                    },
                  ]
                : []),
            ],
          },
        ]}
      />
    </div>
  );
};

export default BaseFooter;
